import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Subject } from 'rxjs';
import { tap, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class SchoolService {
  static schoolAdded$ = new Subject();

  private url: string;
  private getSchoolsBasicInfoUrl: string;
  private getSchoolsByCompanyUrl: string;
  private getEducationalDetailsSchoolUrl: string;
  private addSchoolUrl: string;
  private updateSchoolUrl: string;
  private getSchoolByIdUrl: string;
  private getSchoolBloodStatisticsUrl: string;
  private GetDiseaseMedictionStatisticsUrl: string;
  private GetSchoolBmiStatisticsUrl: string;
  private GetEducationalProgramsBySchoolIdUrl: string;

  constructor(public http: HttpClient) {
    this.url = `${environment.apiUrl}School`;
    this.getSchoolsBasicInfoUrl = `${this.url}/GetSchoolsBasicInformation`;
    this.getSchoolsByCompanyUrl = `${this.url}/GetSchoolsByCompanyId`;
    this.getEducationalDetailsSchoolUrl = `${this.url}/GetSchoolEducationalDetails`;
    this.addSchoolUrl = `${this.url}/AddSchool`;
    this.updateSchoolUrl = `${this.url}/UpdateSchool`;
    this.getSchoolByIdUrl = `${this.url}/GetSchoolById`;
    this.getSchoolBloodStatisticsUrl = `${this.url}/GetBloodGroupStatisticsBySchool`;
    this.GetDiseaseMedictionStatisticsUrl = `${this.url}/GetDiseaseMedictionStatistics`;
    this.GetSchoolBmiStatisticsUrl = `${this.url}/GetSchoolBmiStatistics`;
    this.GetEducationalProgramsBySchoolIdUrl = `${this.url}/GetEducationalPrograms`;
  }

  // get basic information for all active schools
  getSchoolsBasicInformation(companyId: number) {
    return this.http.get(`${this.getSchoolsBasicInfoUrl}/${companyId}`);
  }

  // get schools by company id
  getSchoolsByCompanyId(companyId: number) {
    return this.http.get(`${this.getSchoolsByCompanyUrl}/${companyId}`);
  }

  // get educational details By schoolId
  getEducationalDetailsSchoolBySchoolId(schoolId: number) {
    return this.http.get(`${this.getEducationalDetailsSchoolUrl}/${schoolId}`);
  }

  // add school
  addSchool(data) {
    return this.http.post(this.addSchoolUrl, data)
      .pipe(tap(s => {
        SchoolService.schoolAdded$.next();
        return s;
      }));
  }

  // update school

  updateSchool(data) {
    return this.http.put(this.updateSchoolUrl, data);
  }

  //
  getSchoolById(schoolId: number) {
    return this.http.get(`${this.getSchoolByIdUrl}/${schoolId}`);
  }

  //
  getBloodGroupStatisticsBySchool(bloodGroupIds: number[], classId?: number, sectionId?: number) {
    const s = sectionId != null || sectionId != undefined ? sectionId : '';
    const c = classId != null || classId != undefined ? classId : '';
    const ids = bloodGroupIds.length > 0 ? bloodGroupIds.join() : '';
    return this.http.get(`${this.getSchoolBloodStatisticsUrl}?classId=${c}&sectionId=${s}&bloodGroupsIds=${ids}`);
  }

  getDiseaseMedictionStatistics(medicalType: number, diseaseIds: number[], classId?: number, sectionId?: number) {
    const s = sectionId != null || sectionId != undefined ? sectionId : '';
    const c = classId != null || classId != undefined ? classId : '';
    const ids = diseaseIds.length > 0 ? diseaseIds.join() : '';

    return this.http.get(
      `${this.GetDiseaseMedictionStatisticsUrl}?classId=${c}&sectionId=${s}&diseaseMedicationType=${medicalType}&diseaseIds=${ids}`
    );
  }

  getSchoolBmiStatistics(classId?: number, sectionId?: number, fromDate?: Date, toDate?: Date) {
    const s = sectionId != null || sectionId != undefined ? sectionId : '';
    const c = classId != null || classId != undefined ? classId : '';
    const f = fromDate != null || fromDate != undefined ? fromDate.toISOString() : '';
    const t = toDate != null || toDate != undefined ? toDate.toISOString() : '';

    return this.http.get(`${this.GetSchoolBmiStatisticsUrl}?classId=${c}&sectionId=${s}&fromDate=${f}&toDate=${t}`);
  }

  GetEducationalProgramsBySchoolId(schoolId: number) {
    return this.http.get(`${this.GetEducationalProgramsBySchoolIdUrl}/${schoolId}`);
  }
  GetDefaultWeeklyClass(schoolId: number) {
    return this.http.get(`${this.url}/GetDefaultWeeklyClass/${schoolId}`);
  }
  EditDefaultWeeklyClass(defaultWeeklyClasses: { defaultWeeklyClassesId: number; defaultTeacherWeeklyClasses: number }) {
    return this.http.put(`${this.url}/EditDefaultWeeklyClass`, defaultWeeklyClasses);
  }
}
